export const FUNDING_REQUEST_CONTRACT_TYPES = {
  NON_FACTORED_STANDARD: "NON_FACTORED_STANDARD",
  NON_FACTORED_BILL_OUT: "NON_FACTORED_BILL_OUT",
  SELF_FINANCE_NO_INVOICE: "SELF_FINANCE_NO_INVOICE",
  SELF_FINANCE_WITH_INVOICE: "SELF_FINANCE_WITH_INVOICE",
  STD_BROKER: "STD_BROKER"
};

export const FUNDING_REQUEST_CONTRACT_TYPES_MAP = {
  NON_FACTORED_STANDARD: "Non-Factored Pay Carrier",
  NON_FACTORED_BILL_OUT: "Non-Factored Bill Out Only",
  SELF_FINANCE_NO_INVOICE: "Self Finance No Invoice",
  SELF_FINANCE_WITH_INVOICE: "Self Finance With Invoice",
  STD_BROKER: "Factored"
};

export type FundingRequestContractType = keyof typeof FUNDING_REQUEST_CONTRACT_TYPES_MAP;
